<template>
  <transition appear name="fade" mode="in-out">
    <section
      class="card-container"
      :style="{ '--card-bgColor': cardAdmin.bgColor, '--card-borderRadius': cardAdmin.borderRadius, '--card-subColor': cardAdmin.subColor, '--card-textColor': cardAdmin.textColor, '--card-titleColor': cardAdmin.titleColor }">
      <img class="card-image" :style="imageStyle" :src="card.image" />
      <div class="card-details" :style="cardDetailsStyle">
        <span class="card-add-contact" v-if="card.enableAction && contactsProvider">
          <i :title="`Ver contatos`" class="fas fa-user-check" @click="$router.push('/contacts')" v-if="hideAddContactComputed"></i>
          <i title="Adicionar contato" class="fas fa-user-plus" v-else @click.prevent="addContact(card)"></i>
        </span>
        <span :title="`Contato adicionado`" class="card-add-contact" v-else>
          <!-- <i class="fas fa-user-check"></i> -->
        </span>
        <div class="card-name-and-onair">
          <h3 class="card-name" v-html="card.name"></h3>
        </div>
        <div class="card-role" :style="roleStyle" v-html="card.role"></div>
        <p class="card-description" :style="descriptionStyle" v-html="card.description"></p>
        <div style="display: flex">
          <span class="card-public-events" @click="showCalendar" v-if="$store.state.template.accessConfig.enablePersonalAgenda && card.public_events > 0">
            <i class="far fa-calendar-check"></i>
            {{ card.public_events }} evento
            <span v-if="card.public_events > 1">s</span>
          </span>
        </div>
        <div class="card-action" :class="{ 'card-noURL': !card.enableAction }">
          <div :class="{ 'card-button-enabled': card.enableAction, 'card-button-disabled': !card.enableAction }" @click="action">{{ card.action }}</div>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
import api from '@/services/api.js';

export default {
  name: 'Card',
  props: ['card', 'imageStyle', 'cardDetailsStyle', 'roleStyle', 'descriptionStyle'],

  data() {
    return {
      contactsProvider: false,
      hideAddContact: false,
    };
  },
  computed: {
    hideAddContactComputed() {
      return this.card.contact_added || this.hideAddContact;
    },
  },
  methods: {
    action() {
      const act = this.card.actionType;
      //console.log(this.card.actionType);
      if (act == 'router') {
        //console.log('Routing');

        if (this.card.url === 'Explorer') {
          console.log('Navigating to Explorer with stream:', this.card.target, 'and panel:', this.card.panel);
          let panel = this.card.panel;
          this.$router.push({
            name: 'Explorer',
            params: { stream: this.card.target },
            query: { panel: panel },
          });
        } else {
          this.$router
            .push({
              name: this.card.url,
              params: {
                stream: this.card.target,
              },
            })
            .catch((err) => {
              console.error('navigation error', err);
            });
        }
      } else if (act == 'link') {
        //console.log('link',this.card.url,this.card.target);
        window.open(this.card.url, this.card.target);
      } else if (act == 'inscript') {
        //console.log('Inscript');
        api
          .post(`activity/${this.card.target}/inscript`, { inscript_id: this.$store.state.userId })
          .then((response) => {
            //console.log(response);
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (act == 'talk') {
        api
          .post(`event/${this.$store.state.eventId}/createTalkChannel`, { user_id: this.card.target, channelName: this.card.url })
          .then((response) => {
            // console.log('createTalkChannel', { response });
            if (response.data) {
              this.$root.$emit('openChannel', response.data.talk_channel_id);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (act == 'none') {
        //console.log('Wait');
      } else {
        //console.log('action unknonw');
      }
      //console.log('EMIT');
      this.$emit('finished');
      api.post(`sessionAction/`, {
        action: 'Card Action',
        properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, card: this.card }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
    },
    showCalendar() {
      this.$emit('showCalendar', this.card.target);
    },
    async addContact(card) {
      await this.apiPostContact(card);
      this.hideAddContact = true;
      this.$emit('addContact', card);
    },

    apiPostContact(card) {
      return new Promise((resolve, reject) => {
        let payload = {
          category: 'NETWORK',
          contact_user_id: card.target,
          name: card.name,
          role: card.role,
          image: card.image,
          company: card.company ? card.company : null,
          nickname: card.nickname,
          about_me: card.about_me,
          link: card.url,
          email: null,
          telephone: null,
          date_of_birth: null,
          country: null,
          state: null,
          city: null,
          cep: null,
          street: null,
          number: null,
          complement: null,
          neighborhood: null,
          other: null,
          properties: '{}',
          order: 0,
        };
        api
          .post(`event/${this.$store.state.eventId}/contact`, payload)
          .then((response) => {
            resolve();
          })
          .catch((err) => {
            reject();
            console.error(err);
          });
      });
    },
  },
  beforeMount() {
    this.cardAdmin = this.$store.state.template.foyerCard;
    this.contactsProvider = this.$store.state.template.userProfile.contactsProvider.name == 'Network';
  },
  mounted() {
    this.card.name = this.card.name.toLowerCase();
  },
};
</script>

<style lang="scss">
p {
  overflow-y: hidden; // in case we get more text than fits the card
}

.card-container {
  position: relative;
  transition: 0.3s;
  background-color: var(--card-bgColor);
  border-radius: var(--card-borderRadius);
  box-shadow: 4px 10px 16px 0 rgba(0, 0, 0, 0.2);

  &:hover {
    transform: scale(1.1);
    transition: 0.3s;
  }
}

.card-image {
  display: block;
  width: 220px;
  object-fit: cover;
  object-position: top;
  border-top-left-radius: var(--card-borderRadius);
  border-top-right-radius: var(--card-borderRadius);
}

.card-details {
  padding: 3% 0% 0% 0%;
  height: 60%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.card-name-and-onair {
  display: flex;
}

.card-onair {
  width: 20px;
  height: 20px;
  background-color: green;
  border-radius: 50%;
  margin-left: auto;
}

.card-public-events {
  position: absolute;
  top: 6px;
  margin: 0 auto 0 5px;
  cursor: pointer;
  font-size: 0.97rem;
}

.card-add-contact {
  position: absolute;
  margin-left: auto;
  padding: 6px 6px 6px 10px;
  top: 4px;
  right: 4px;
  width: 30px;
  height: 30px;
  z-index: 0;
  color: var(--button-background);
  background: var(--button-text);
  border-radius: var(--card-borderRadius);

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 200ms ease-in-out;

  &:hover {
    transform: scale(1.5);
    // background-color: #404040;
  }

  i {
    font-size: 1rem;
  }
}

.card-name {
  font-size: 1.2rem;
  // line-height: 1.2;
  color: var(--card-titleColor);
  font-weight: 700;
  margin: 1% 2% 0 6%;
  text-transform: capitalize;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-role {
  display: inline-block;
  margin: 1% 2% 0 6%;
  padding: 0 0 0.5rem 0;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--card-subColor);
  opacity: 0.8;
}

.card-description {
  color: var(--card-textColor);
  font-size: 0.9rem;
  height: 10vh;
  flex-grow: 1;
  margin-bottom: 6px;
  padding-right: 6px;
  overflow-y: auto;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  /* number of lines to show */
  -webkit-box-orient: vertical;
}

.card-action {
  font-size: 0.8rem;
  line-height: 3;
  text-align: center;
  // z-index: 1;
  cursor: pointer;
}

.card-button-disabled {
  color: var(--button-background);
  background-color: transparent;
  border: 2px solid var(--button-background);
  border-bottom-left-radius: var(--card-borderRadius);
  border-bottom-right-radius: var(--card-borderRadius);
}

.card-noURL {
  cursor: auto;
  pointer-events: none;
}

.card-button-enabled {
  color: var(--button-text);
  background-color: var(--button-background);
  border: 2px solid var(--button-background);
  border-bottom-left-radius: var(--card-borderRadius);
  border-bottom-right-radius: var(--card-borderRadius);
}
</style>
